/* global tw */
import { css } from 'react-emotion';

export const hidden = css`
  ${tw('hidden xl:block')};
`;
